import { render } from "./ASideUserInfo.vue?vue&type=template&id=49b715b8&scoped=true"
import script from "./ASideUserInfo.vue?vue&type=script&lang=js"
export * from "./ASideUserInfo.vue?vue&type=script&lang=js"

import "./ASideUserInfo.vue?vue&type=style&index=0&id=49b715b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49b715b8"]])

export default __exports__